import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import useBreakpoint from '@utils/useBreakpoint';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Keyboard, Controller } from 'swiper';
import '@moncler/scss/components/collection-inpage-navigation/collection-inpage-navigation-simplified.scss';
import classNames from 'classnames';
import Lazyimg from '@components/utils/Lazyimg';
SwiperCore.use([Keyboard, Navigation, Controller]);
const CollectionInpageNavigation = (props) => {
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const [componentData, setComponentData] = useState(null);
    const [columns, setColumns] = useState([]);
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const isMobile = currentBreakpoint < parseInt(window.mqObj.sm.toString());
    useEffect(() => {
        var _a;
        let pageID = (_a = document.body.id) === null || _a === void 0 ? void 0 : _a.replace('page-', '');
        if (pageID) {
            api.getPageJson(pageID, true).then((data) => {
                var _a;
                let componentDataRes = (_a = data.regions[0].components) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === props.uuid);
                setComponentData(componentDataRes.data);
                setColumns(componentDataRes.regions[0].components);
            });
        }
    }, []);
    const renderArrows = () => (React.createElement("div", { className: classNames('collections-inpage-navigation-simplified__arrows', { hidden: !isMobile }) },
        React.createElement("button", { type: "button", ref: prevRef, className: `${props.uuid}--prev`, "aria-label": t('carousel.prevslidemessage') },
            React.createElement("i", { className: "icon--chevron-left-big", "aria-hidden": true })),
        React.createElement("button", { type: "button", ref: nextRef, className: `${props.uuid}--next`, "aria-label": t('carousel.nextslidemessage') },
            React.createElement("i", { className: "icon--chevron-right-big", "aria-hidden": true }))));
    if (!componentData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container" },
            React.createElement("p", { className: "collections-title primary-l" }, componentData.title),
            React.createElement(Swiper, { className: "collections-carousel", slidesPerView: 'auto', spaceBetween: 16, updateOnWindowResize: true, breakpoints: { 601: { spaceBetween: 0, enabled: false } }, navigation: {
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                } }, columns.map((column) => (React.createElement(SwiperSlide, { key: column.id, onClick: () => {
                    const link = document.getElementById(`collection-link-${column.id}`);
                    link.click();
                } },
                React.createElement("picture", { className: "collection-image-bg" },
                    React.createElement("source", { media: "(max-width: 768px)", srcSet: column.custom.images['mobile'].src }),
                    React.createElement(Lazyimg, { src: column.custom.images['desktop'].src, alt: '' })),
                React.createElement("div", { className: "collection-content" },
                    React.createElement("img", { className: "logo", src: column.custom.images['logo'].src, alt: "logo" }),
                    React.createElement("p", { className: "collection-content-title primary-m" }, column.data.name),
                    React.createElement("div", { className: "collection-content-description primary-s", dangerouslySetInnerHTML: { __html: column.data.description } }),
                    React.createElement("a", { href: column.data.link, className: classNames('button', 'button--tertiary-inverted', 'button--arrow-right'), id: `collection-link-${column.id}` }, column.data.linkText))))))),
        renderArrows()));
};
export default CollectionInpageNavigation;
